exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".fa-margin{margin-right:10px}.navbar-inverse{border-color:#480000;border-bottom-width:2px}h4{font-size:18px}.bk{background:url(/public/img/bk.png) repeat-x;background-color:#000}a{font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./app/admin/admin.component.css
// module id = 406
// module chunks = 0